<template>
  <el-breadcrumb class="bread-crumb">
    <!-- <el-breadcrumb-item >当前位置</el-breadcrumb-item>
    <el-breadcrumb-item 
      v-for="item in breadArrRender" 
      :key="item.key"
    >
      <span>{{ item.name }}</span>
    </el-breadcrumb-item> -->
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    menuData: {
      type: Array
    },
  },
  data() {
    return {
      path: [],
      cacheHref: ""
    };
  },
  computed: {
    ...mapGetters(["breadArr"]),
    breadArrRender() {
      const arr = [];
      this.breadArr.forEach(element => {
        if (element && element.key) {
          arr.push(element);
        }
      });
      return arr;
    }
  },
};
</script>

<style lang="scss" scoped>
.bread-crumb {
  line-height: 30px;
  height: 30px;
  color: #666;
  font-size: 12px;
  .now-position {
    margin-right: 10px;
    color: #999;
  }
  .el-breadcrumb__inner,
  .el-breadcrumb__inner a {
    color: #999;
    font-weight: normal;
  }
  .clickable {
    .el-breadcrumb__inner {
      color: #0061dc;
    }
  }
  .clickable.el-breadcrumb__item:last-child {
    .el-breadcrumb__inner {
      color: #666;
    }
  }
}
</style>
